import { render, staticRenderFns } from "./journeyPreview.vue?vue&type=template&id=12e9249c&scoped=true&"
import script from "./journeyPreview.vue?vue&type=script&lang=js&"
export * from "./journeyPreview.vue?vue&type=script&lang=js&"
import style0 from "./journeyPreview.vue?vue&type=style&index=0&id=12e9249c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e9249c",
  null
  
)

export default component.exports